import React from 'react';
import Slider from 'react-slick';
import Bootstrap from '../components/logos/Bootstrap';
import ReactLogo from '../components/logos/ReactLogo';
import CRALogo from '../components/logos/CRALogo';
import StorybookLogo from '../components/logos/StorybookLogo';
import FormikLogo from '../components/logos/FormikLogo';
import ApexChartsLogo from '../components/logos/ApexChartsLogo';
import MaterialIconsLogo from '../components/logos/MaterialIconsLogo';
import EslintLogo from '../components/logos/EslintLogo';
import StylelintLogo from '../components/logos/StylelintLogo';
import PrettierLogo from '../components/logos/PrettierLogo';

const settings = {
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 6,
	slidesToScroll: 1,
	autoplay: true,
	responsive: [
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
	],
};

// eslint-disable-next-line react/prop-types
const Item = ({ children }) => (
	<div
		style={{ padding: '0 10%' }}
		className='slide-item d-flex justify-content-center align-items-center h-100'>
		{children}
	</div>
);

const SectionCredits = () => (
	<div className='row credits-row'>
		<div className='col-12 fw-bold h5 text-light mb-5 text-center text-uppercase'>Credits</div>
		<div className='col-12 px-5 px-md-0'>
			{/* eslint-disable-next-line react/jsx-props-no-spreading */}
			<Slider {...settings}>
				<Item>
					<ReactLogo />
				</Item>
				<Item>
					<Bootstrap />
				</Item>
				<Item>
					<CRALogo />
				</Item>
				<Item>
					<StorybookLogo />
				</Item>
				<Item>
					<FormikLogo />
				</Item>
				<Item>
					<ApexChartsLogo />
				</Item>
				<Item>
					<MaterialIconsLogo />
				</Item>
				<Item>
					<EslintLogo />
				</Item>
				<Item>
					<StylelintLogo />
				</Item>
				<Item>
					<PrettierLogo />
				</Item>
			</Slider>
		</div>
	</div>
);

export default SectionCredits;
